import { formatDateInputValue } from "../shared/utils/format";

export const crearCitaVacia = (valores = {}) => ({
  IdCita: null,
  IdPaciente: "",
  Fecha: "",
  Costo: "",
  IdTiposCita: "",
  Descuento: 0,
  IVA: 0,
  ...valores
});

export const pad2 = (value) => String(value).padStart(2, "0");

export const crearFechaHora = ({ date, hour12, minute, meridiem }) => {
  if (!date || !hour12 || minute === "" || !meridiem) return "";

  let hour24 = Number(hour12) % 12;
  if (meridiem === "PM") hour24 += 12;

  return `${date}T${pad2(hour24)}:${pad2(Number(minute))}`;
};

export const obtenerPartesFechaHora = (fecha) => {
  const ahora = new Date();
  const fechaActual = formatDateInputValue(ahora);
  const horaActual = ahora.getHours();
  const minutoActual = ahora.getMinutes();

  const fechaNormalizada = String(fecha || "").replace(" ", "T");
  const [dateRaw, timeRaw] = fechaNormalizada.split("T");
  const date = dateRaw || fechaActual;
  const time = timeRaw || `${pad2(horaActual)}:${pad2(minutoActual)}`;
  const [hourRaw = horaActual, minuteRaw = minutoActual] = time.split(":");
  const hour24 = Number(hourRaw);
  const minute = Number(minuteRaw);
  const hour12 = hour24 % 12 || 12;

  return {
    date,
    hour12: pad2(hour12),
    minute: pad2(Number.isNaN(minute) ? 0 : minute),
    meridiem: hour24 >= 12 ? "PM" : "AM"
  };
};

export const crearFechaHoraActual = () => crearFechaHora(obtenerPartesFechaHora(""));

export const normalizarFechaParaApi = (fecha) => {
  const partes = obtenerPartesFechaHora(fecha);
  return `${crearFechaHora(partes).replace("T", " ")}:00`;
};

export const crearPayloadCita = (formulario) => ({
  IdCita: formulario.IdCita,
  IdPaciente: formulario.IdPaciente,
  Fecha: normalizarFechaParaApi(formulario.Fecha),
  Costo: formulario.Costo,
  IdTiposCita: formulario.IdTiposCita,
  Descuento: formulario.Descuento,
  IVA: formulario.IVA
});
